import { logout } from "../../UserSlice"; // Import the logout action

export const logoutUser = () => async (dispatch) => {
    try {
        localStorage.removeItem("jwtToken"); // Clear token from storage
        dispatch(logout()); // Use the logout action from userSlice
    } catch (error) {
        console.error("Error during logout:", error.message);
    }
};
